<template>
  <div>
    <div class="regisInfo">
      <div class="left">
        <div class="title">{{ form.zpqsbt + " - " + form.zpdw }}</div>
      </div>
      <div class="view" @click="showOrHide()">
        {{ detailMessage[showDetails ? 1 : 0] }}
      </div>
      <div class="right">
        <span @click="print">下载报名表</span>
        <!-- <span @click="modifyRegisInfo">修改</span> -->
        <span @click="deleteRegisInfo">删除</span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="right"
      label-width="150px"
      v-show="showDetails"
    >
      <div class="header">
        <div>岗位信息</div>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="招聘启事">
            <el-input v-model="form.zpqsbt" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="招聘单位">
            <el-input v-model="form.zpdw" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="招聘岗位">
            <el-input v-model="form.gwmc" :disabled="!editing" :readonly="true">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="openZpgwDialog"
                v-if="editing"
              ></el-button
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-dialog title="招聘岗位查询/选择" :visible.sync="zpgwLov.show">
        <el-form-item label="岗位名称" label-width="100px">
          <el-input v-model="zpgwLov.gwmc" placeholder="请输入">
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="queryZpgw"
            ></el-button>
          </el-input>
        </el-form-item>
        <el-table
          :data="zpgwLov.table"
          style="width: 100%"
          @row-dblclick="tableRowDbclickBackfill"
        >
          <el-table-column prop="zpdw" label="招聘单位"> </el-table-column>
          <el-table-column prop="gwmc" label="岗位名称"> </el-table-column>
          <el-table-column prop="jhrs" label="计划人数"> </el-table-column>
        </el-table>
      </el-dialog>
      <div class="header">
        <div>基本信息</div>
      </div>
      <el-row>
        <el-col :span="16">
          <el-col :span="12">
            <el-form-item label="身份证号" prop="identityNumber">
              <el-input
                v-model="form.identityNumber"
                placeholder="请输入"
                :disabled="!editing"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入"
                :readonly="false"
                :disabled="!editing"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="gender">
              <el-select
                v-model="form.gender"
                style="width: 100%"
                :disabled="!editing"
              >
                <el-option
                  v-for="item in options.genderList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生地" prop="birthPlace">
              <el-input
                v-model="form.birthPlace"
                placeholder="请输入"
                :disabled="!editing"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="民族" prop="nation">
              <el-select
                v-model="form.nation"
                style="width: 100%"
                :disabled="!editing"
              >
                <el-option
                  v-for="item in options.nationList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生年月" prop="birthDate">
              <el-date-picker
                v-model="form.birthDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                style="width: 100%"
                :disabled="!editing"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="政治面貌" prop="politicsFace">
              <el-select
                v-model="form.politicsFace"
                style="width: 100%"
                :disabled="!editing"
              >
                <el-option
                  v-for="item in options.politicsFaceList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入党时间" prop="joinPartyDate">
              <el-date-picker
                v-model="form.joinPartyDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                style="width: 100%"
                :disabled="!editing"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="毕业时间" prop="bysj">
              <el-date-picker
                v-model="form.bysj"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                style="width: 100%"
                :disabled="!editing"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="简历投递时间" prop="jltdsj">
              <el-date-picker
                      v-model="form.jltdsj"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择"
                      style="width: 100%"
                      :disabled="!editing"
              >
              </el-date-picker>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="移动电话" prop="telPhone">
              <el-input
                v-model="form.telPhone"
                placeholder="请输入"
                :disabled="!editing"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                v-model="form.contactPhone"
                placeholder="请输入"
                :disabled="!editing"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="家庭住址" prop="homeAddress">
              <el-input
                v-model="form.homeAddress"
                placeholder="请输入"
                :disabled="!editing"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-col>
        <el-col :span="8">
          <div class="baseinfo-image">
            <img class="image" :src="form.imageSrc" />
            <el-upload
              action=""
              :on-change="imageChange"
              :show-file-list="false"
              :auto-upload="false"
            >
              <el-button size="small" type="primary" v-show="editing"
                >上传图片</el-button
              >
            </el-upload>
            <div class="red" :class="{ show: showMessage, hide: !showMessage }">
              请上传照片
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="header">
        <div>学习经历</div>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="学历" prop="firstEducation">
            <el-select
              v-model="form.firstEducation"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.educationList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="学位" prop="firstDegree">
            <el-select
              v-model="form.firstDegree"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.degreeList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="学制" prop="firstPeriod">
            <el-select
              v-model="form.firstPeriod"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.periodList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="毕业院校" prop="firstCollege">
            <el-input
              v-model="form.firstCollege"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="毕业时间" prop="firstGraduationDate">
            <el-date-picker
              v-model="form.firstGraduationDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="专业" prop="firstProfession">
            <el-input
              v-model="form.firstProfession"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="院校类别" prop="collegeCategory">
            <el-select
              v-model="form.collegeCategory"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.collegeList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身高" prop="height">
            <el-input
              v-model="form.height"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="体重" prop="weight">
            <el-input
              v-model="form.weight"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="8">
          <el-form-item label="后续学历" prop="followEducation">
            <el-select
              v-model="form.followEducation"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.educationList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="后续学历学位" prop="followDegree">
            <el-select
              v-model="form.followDegree"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.degreeList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="后续学历学制" prop="followPeriod">
            <el-select
              v-model="form.followPeriod"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            >
              <el-option
                v-for="item in options.periodList"
                :key="item.value"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="后续学历毕业院校" prop="followCollege">
            <el-input
              v-model="form.followCollege"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="后续学历毕业时间" prop="followGraduationDate">
            <el-date-picker
              v-model="form.followGraduationDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="后续学历专业" prop="followProfession">
            <el-input
              v-model="form.followProfession"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <div class="header">
        <div>现工作情况</div>
      </div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="参加工作时间" prop="toWorkDate">
            <el-date-picker
              v-model="form.toWorkDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="独立公司名称" prop="company">
            <el-input
              v-model="form.company"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="部门名称" prop="department">
            <el-input
              v-model="form.department"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职务+层级" prop="post">
            <el-input
              v-model="form.post"
              placeholder="请输入"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="专业技术资格及取得时间">
            <!-- <el-date-picker
              v-model="form.ExpertiseObtainDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            ></el-date-picker> -->
            <el-input
              v-model="form.ExpertiseObtainDate"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="技能等级及取得时间">
            <!-- <el-date-picker
              v-model="form.appointmentDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              style="width: 100%"
              :disabled="!editing"
            ></el-date-picker> -->
            <el-input
              v-model="form.appointmentDate"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="header">
        <div>
          <span class="red">*</span>工作经历
          <!-- <div class="red" v-show="showResumeMessage">
            请添加工作培训学习简历
          </div> -->
        </div>
        <!-- <el-button type="primary" @click="addResume" :disabled="!editing"
          >+工作及学习培训简历</el-button
        > -->
      </div>
      <el-row>
        <el-col :span="24">
          <el-form-item label="" label-width="0" prop="gzpxxxjl">
            <el-input
              type="textarea"
              v-model="form.gzpxxxjl"
              rows="3"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-form-item prop="resume" label-width="0px"> -->
      <!-- <el-row
        v-for="(item, index) in form.resume"
        :key="item.startDate + item.endDate + item.location + 'resume' + index"
      >
        <hr v-if="index > 0" />
        <el-row v-if="item.show">
          <el-col :span="8">
            <el-form-item label="时间：">
              {{ item.startDate + "至" + item.endDate }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="地点：">
              {{ item.location }}
            </el-form-item>
          </el-col>
          <el-col :span="2" :offset="4">
            <el-form-item label="" label-width="0">
              <div class="modify" @click="modifyResume(item)" v-show="editing">
                修改
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="" label-width="0">
              <div class="delete" @click="delResume(index)" v-show="editing">
                删除
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="工作及培训学习内容：">
              {{ item.content }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-form
          :ref="'itemResume' + index"
          :model="item"
          :rules="resumeRules"
          label-position="right"
          label-width="150px"
        >
          <el-row :class="{ show: item.modified, hide: !item.modified }">
            <el-col :span="8">
              <el-form-item label="开始时间：" prop="editableStartDate">
                <el-date-picker
                  v-model="item.editableStartDate"
                  type="date"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="终止时间：" prop="editableEndDate">
                <el-date-picker
                  v-model="item.editableEndDate"
                  type="date"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="地点：" prop="editableLocation">
                <el-input
                  v-model="item.editableLocation"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="工作培训学习内容：" prop="editableContent">
                <el-input
                  type="textarea"
                  v-model="item.editableContent"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4" :offset="10">
              <el-button
                type="primary"
                @click="saveResume(item, index)"
                :disabled="!editing"
                >保存</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </el-row> -->
      <!-- </el-form-item> -->
      <div class="header">
        <div>
          <span class="red">*</span>家庭主要成员
          <div class="red" v-show="showHomeMemberMessage">
            请添加家庭主要成员
          </div>
        </div>
        <el-button type="primary" @click="addHomeMember" :disabled="!editing"
          >+家庭成员</el-button
        >
      </div>
      <el-row
        v-for="(item, index) in form.homeMainMember"
        :key="item.name + item.age + 'homeMember' + index"
      >
        <hr v-if="index > 0" />
        <el-row v-if="item.show">
          <el-col :span="6">
            <el-form-item label="姓名：">
              {{ item.name }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="与本人关系：">
              {{ getCodeLabel("ybrgx", item.relationship) }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="年龄：">
              {{ item.age }}
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="" label-width="0">
              <div
                class="modify"
                @click="modifyHomeMember(item)"
                v-show="editing"
              >
                修改
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item label="" label-width="0">
              <div
                class="delete"
                @click="delHomeMember(index)"
                v-show="editing"
              >
                删除
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="学历：">
              {{ item.degree }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="专业：">
              {{ item.profession }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="现工作单位及岗位：">
              {{ item.companyAndPost }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-form
          :ref="'itemHomeMember' + index"
          :model="item"
          :rules="homeMemberRules"
          label-position="right"
          label-width="150px"
        >
          <el-row :class="{ show: item.modified, hide: !item.modified }">
            <el-col :span="8">
              <el-form-item label="姓名：" prop="editableName">
                <el-input
                  v-model="item.editableName"
                  placeholder="请填写"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="与本人关系：" prop="editableRelationship">
                <el-select
                  v-model="item.editableRelationship"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options.ybrgx"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="年龄：" prop="editableAge">
                <el-input
                  v-model="item.editableAge"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学历：" prop="editableDegree">
                <el-input
                  v-model="item.editableDegree"
                  placeholder="请填写"
                ></el-input>
                <!--<el-select
                  v-model="item.editableDegree"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options.xl"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>-->
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="专业：" prop="editableProfession">
                <el-input
                  v-model="item.editableProfession"
                  placeholder="请填写"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="现工作单位及岗位："
                prop="editableCompanyAndPost"
              >
                <el-input
                  v-model="item.editableCompanyAndPost"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4" :offset="10">
              <el-button
                type="primary"
                @click="saveHomeMember(item, index)"
                :disabled="!editing"
                >保存</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </el-row>
      <div class="header">
        <div>
          <!-- <span class="red">*</span> -->
          备注
        </div>
      </div>
      <el-row>
        <el-col :span="24">
          <el-form-item label="" label-width="0" prop="note">
            <el-input
              type="textarea"
              v-model="form.note"
              rows="5"
              :disabled="!editing"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2" :offset="22">
          <el-button type="primary" v-show="editing" @click="submitModification"
            >提交修改</el-button
          >
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import share from "@/assets/sharejs/share.js";
import request from "@/api/personCenter.js";
export default {
  props: {
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      zpgwLov: {
        show: false, //是否显示招聘岗位查询/选择模态框
        gwmc: "", //招聘岗位-岗位查询
        table: [], //岗位查询结果
      },
      editing: false, // 是否正在修改编辑
      detailMessage: ["查看报名信息", "收起报名信息"],
      showDetails: false, //显示或收起报名信息
      showMessage: false, //是否显示上传图片信息
      showResumeMessage: false, //是否显示 添加培训学习简历 文本
      showHomeMemberMessage: false, //是否显示 添加培训学习简历 文本
      cloneForm: {}, //用于复制form，以便修改时，数据复原
      form: {
        zpqsbt: "", //招聘启事标题
        zpqsid: "", //招聘启事id
        zpdw: "", //招聘单位
        gwmc: "", //岗位名称
        gwid: "", //招聘岗位id
        zpbmid: "", //招聘报名id

        identityNumber: "", //身份证号
        name: "", //姓名
        gender: "", //性别
        birthPlace: "", //出生地
        nation: "", //民族
        birthDate: "", //出生年月
        politicsFace: "", //政治面貌
        joinPartyDate: "", //入党时间
        telPhone: "", //手机号
        contactPhone: "", //联系电话
        homeAddress: "", //家庭住址
        imageSrc: "", //图片

        firstEducation: "", //第一学历
        firstDegree: "", //第一学历学位
        firstPeriod: "", //第一学历学制
        firstCollege: "", //第一学历毕业院校
        firstGraduationDate: "", //第一学历毕业时间
        firstProfession: "", //第一学历专业
        collegeCategory: "", //院校类别
        // jltdsj: "", //简历投递时间
        bysj: "", //毕业时间
        height: "", //身高
        weight: "", //体重
        // followEducation: "", //后续学历
        // followDegree: "", //后续学历学位
        // followPeriod: "", //后续学历学制
        // followCollege: "", //后续学历毕业院校
        // followGraduationDate: "", //后续学历毕业时间
        // followProfession: "", //后续学历专业

        toWorkDate: "", //参加工作时间
        company: "", //现工作单位
        department: "", //现工作部门
        post: "", //职务或岗位
        ExpertiseObtainDate: "", //专业技术资格取得时间
        appointmentDate: "", //现聘专业技术岗位及聘任时间

        // resume: [], //工作培训及学习简历
        gzpxxxjl: "", //工作培训学习简历
        homeMainMember: [], //家庭主要成员
        note: "", //备注1
      },
      rules: {
        identityNumber: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: ["blur", "change"],
          },
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: ["blur", "change"],
          },
        ],
        birthPlace: [
          {
            required: true,
            message: "请输入出生地",
            trigger: ["blur", "change"],
          },
        ],
        nation: [
          {
            required: true,
            message: "请选择民族",
            trigger: ["blur", "change"],
          },
        ],
        birthDate: [
          {
            required: true,
            message: "请选择出生年月",
            trigger: ["blur", "change"],
          },
        ],
        politicsFace: [
          {
            required: true,
            message: "请选择政治面貌",
            trigger: ["blur", "change"],
          },
        ],
        joinPartyDate: [
          // {
          //   required: true,
          //   message: "请选择入党时间",
          //   trigger: ["blur", "change"]
          // }
        ],
        telPhone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            type: "string",
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "请输入有效的手机号码",
            trigger: "blur",
          },
        ],
        contactPhone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: ["blur", "change"],
          },
        ],
        homeAddress: [
          {
            required: true,
            message: "请输入家庭住址",
            trigger: ["blur", "change"],
          },
        ],
        firstEducation: [
          {
            required: true,
            message: "请选择学历",
            trigger: ["blur", "change"],
          },
        ],
        firstDegree: [
          {
            required: true,
            message: "请选择学位",
            trigger: ["blur", "change"],
          },
        ],
        firstPeriod: [
          {
            required: true,
            message: "请选择学制",
            trigger: ["blur", "change"],
          },
        ],
        firstCollege: [
          {
            required: true,
            message: "请填写毕业院校",
            trigger: ["blur", "change"],
          },
        ],
        firstGraduationDate: [
          {
            required: true,
            message: "请填写毕业时间",
            trigger: ["blur", "change"],
          },
        ],
        firstProfession: [
          {
            required: true,
            message: "请填写专业",
            trigger: ["blur", "change"],
          },
        ],
        collegeCategory: [
          {
            required: true,
            message: "请选择院校类别",
            trigger: ["blur", "change"],
          },
        ],
        height: [
          {
            required: true,
            message: "请填写身高",
            trigger: ["blur", "change"],
          },
        ],
        weight: [
          {
            required: true,
            message: "请填写体重",
            trigger: ["blur", "change"],
          },
        ],
        toWorkDate: [
          {
            required: true,
            message: "请选择参加工作时间",
            trigger: ["blur", "change"],
          },
        ],
        company: [
          {
            required: true,
            message: "请填写现工作单位",
            trigger: ["blur", "change"],
          },
        ],
        department: [
          {
            required: true,
            message: "请填写现工作部门",
            trigger: ["blur", "change"],
          },
        ],
        post: [
          {
            required: true,
            message: "请填写职务或岗位",
            trigger: ["blur", "change"],
          },
        ],
        ExpertiseObtainDate: [
          {
            required: true,
            message: "请选择专业技术资格取得时间",
            trigger: ["blur", "change"],
          },
        ],
        appointmentDate: [
          {
            required: true,
            message: "请选择聘任时间",
            trigger: ["blur", "change"],
          },
        ],
        gzpxxxjl: [
          {
            required: true,
            message: "请填写工作培训学习简历",
            trigger: ["blur", "change"],
          },
        ],
        // note: [
        //   { required: true, message: "请填写备注", trigger: ["blur", "change"] }
        // ]
      },
      resumeRules: {
        editableStartDate: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        editableEndDate: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
        ],
        editableLocation: [
          { required: true, message: "请填写地点", trigger: "blur" },
        ],
        editableContent: [
          {
            required: true,
            message: "请填写工作培训学习内容",
            trigger: "blur",
          },
        ],
      },
      homeMemberRules: {
        editableName: [
          { required: true, message: "请填写姓名", trigger: "blur" },
        ],
        editableRelationship: [
          {
            required: true,
            message: "请填写与本人关系",
            trigger: ["blur", "change"],
          },
        ],
        editableAge: [
          { required: true, message: "请填写年龄", trigger: "blur" },
        ],
        editableDegree: [
          {
            required: true,
            message: "请填写学历",
            trigger: ["blur", "change"],
          },
        ],
        editableProfession: [
          { required: true, message: "请填写专业", trigger: "blur" },
        ],
        editableCompanyAndPost: [
          {
            required: true,
            message: "请填写现工作单位及岗位",
            trigger: "blur",
          },
        ],
      },
      options: {
        genderList: share.get("xb"),
        nationList: share.get("mz"),
        politicsFaceList: share.get("zzmm"),
        educationList: [
          {key: '40', value: '中等专科'},
          {key: '30', value: '大学专科'},
          {key: '20', value: '大学本科'},
          {key: '14', value: '硕士研究生'},
          {key: '11', value: '博士研究生'},
        ],
        degreeList: share.get("xw"),
        periodList: share.get("xz"),
        collegeList: share.get("lb"), //学校类别
        ybrgx: share.get("ybrgx"), //与本人关系
      },
    };
  },
  watch: {
    formData: {
      handler: function (newValue) {
        this.handlePropsData(newValue);
      },
      immediate: true,
    },
    "form.identityNumber": function (newValue) {
      if (newValue.length == 18) {
        this.form.gender =
          parseInt(newValue.substr(16, 1)) % 2 == 1 ? "1" : "2"; //奇数男，偶数女
        this.form.birthDate =
          newValue.substr(6, 4) +
          "-" +
          newValue.substr(10, 2) +
          "-" +
          newValue.substr(12, 2);
      }
    },
    "form.politicsFace": {
      handler: function (newValue) {
        if (newValue == "01") {
          this.$set(this.rules, "joinPartyDate", [
            {
              required: true,
              message: "请选择入党时间",
              trigger: ["blur", "change"],
            },
          ]);
        } else {
          this.$set(this.rules, "joinPartyDate", []);
          this.$refs.form.clearValidate("joinPartyDate");
        }
      },
      // immediate: true
    },
    "form.imageSrc": function (newValue) {
      if (newValue == "") {
        this.showMessage = true;
      } else {
        this.showMessage = false;
      }
    },
    // "form.resume": {
    //   handler: function(newValue) {
    //     if (newValue.length > 0 && newValue[0].show) {
    //       this.showResumeMessage = false;
    //     } else {
    //       this.showResumeMessage = true;
    //     }
    //   },
    //   deep: true
    // },
    "form.homeMainMember": {
      handler: function (newValue) {
        if (newValue.length > 0 && newValue[0].show) {
          this.showHomeMemberMessage = false;
        } else {
          this.showHomeMemberMessage = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    /**
     * 打印报名表
     */
    print() {
      let param = {
        zpbmid: this.form.zpbmid,
      };
      request
        .doPrintBmdjb(param)
        .then((res) => {
          console.log("success");
          console.log(res);
          let file = JSON.parse(window.atob(res.djb));
          console.log(window.atob(res.djb));
          console.log(file);
          let base64 =
            "data:application/vnd.ms-excel;base64," + file.fileBase64;
          let a = document.createElement("a");
          a.setAttribute("href", base64);
          a.setAttribute("download", "报名登记表." + file.fileType);
          a.setAttribute("target", "_blank");
          a.click();
        })
        .catch((err) => {
          console.log("error");
          console.log(err);
        });
    },
    /**
     * 提交保存修改
     */
    submitModification() {
      if (this.validate()) {
        let param = {
          yhid: this.$store.state.userInfo.yhid, //用户id
          zpbmid: this.form.zpbmid, //招聘报名id
          zpqsid: this.form.zpqsid, //招聘启事id
          zpgwid: this.form.gwid, //招聘岗位id
          ...this.getData(),
        };
        request
          .modifyBmxx(param)
          .then((res) => {
            console.log("success");
            console.log(res);
            this.editing = false;
            this.$message({
              message: "修改成功",
              type: "success",
              showClose: true,
            });
          })
          .catch((err) => {
            console.log("error");
            console.log(err);
          });
      }
    },
    /**
     * 修改报名信息
     */
    modifyRegisInfo() {
      //如果当前是正在修改，则表示改为不可编辑，并将数据复原；否则，拷贝一份原数据，以便下次复原
      if (this.editing) {
        this.form = this.cloneForm;
      } else {
        // this.cloneForm = Object.assign({}, this.form);
        this.cloneForm = JSON.parse(JSON.stringify(this.form));
      }
      this.editing = !this.editing;
      this.showDetails = true;
    },
    /**
     * 删除报名信息
     */
    deleteRegisInfo() {
      this.$confirm("确认删除本条报名信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            zpbmid: this.form.zpbmid,
          };
          request
            .deleteBmxx(param)
            .then((res) => {
              this.$message({
                message: "删除成功",
                type: "success",
                showClose: true,
              });
              this.$emit("deleted");
              console.log("success");
              console.log(res);
            })
            .catch((err) => {
              console.log("error");
              console.log(err);
            });
        })
        .catch(() => {});
    },
    /**
     * 弹框表格某一行双击回填
     */
    tableRowDbclickBackfill(row) {
      console.log("77");
      this.form.gwmc = row.gwmc;
      this.form.zpdw = row.zpdw;
      this.form.gwid = row.zpgwid;
      this.zpgwLov.table = [];
      this.zpgwLov.show = false;
    },
    /**
     * 查询招聘岗位
     */
    queryZpgw() {
      let param = {
        zpqsid: this.form.zpqsid,
        gwmc: this.zpgwLov.gwmc,
      };
      request
        .queryZpgwInfo(param)
        .then((res) => {
          this.zpgwLov.table = res.vds;
          console.log("success");
          console.log(res);
        })
        .catch((err) => {
          console.log("error");
          console.log(err);
        });
    },
    /**
     * 打开岗位查询/选择模态框
     */
    openZpgwDialog() {
      this.zpgwLov.show = true;
    },
    /**
     * 显示或隐藏报名信息
     */
    showOrHide() {
      this.showDetails = !this.showDetails;
    },
    /**
     * 将props中传的数据中的日期格式化
     */
    formatPropsDateToFormDate(date) {
      //date要么未空，要么yyyyMMdd，要么yyyy-MM-dd
      if (/\d{8}/.test(date)) {
        return (
          date.substr(0, 4) + "-" + date.substr(4, 2) + "-" + date.substr(6, 2)
        );
      }
      return date;
    },
    /**
     * 处理props传递的数据
     */
    handlePropsData(newValue) {
      this.form.zpqsbt = newValue.zpqsbt; //招聘启事标题
      this.form.zpqsid = newValue.zpqsid; //招聘启事id
      this.form.zpdw = newValue.zpdw; //招聘单位
      this.form.gwmc = newValue.gwmc; //岗位名称
      this.form.gwid = newValue.zpgwid; //岗位名称
      this.form.zpbmid = newValue.zpbmid; //招聘报名id

      this.form.name = newValue.xm; //姓名
      this.form.gender = newValue.xb; //性别
      this.form.nation = newValue.mz; //民族
      this.form.birthDate = this.formatPropsDateToFormDate(newValue.csrq); //出生日期
      this.form.birthPlace = newValue.csd; //出生地
      this.form.politicsFace = newValue.zzmm; //政治面貌
      this.form.joinPartyDate = this.formatPropsDateToFormDate(newValue.rdsj); //入党时间
      this.form.identityNumber = newValue.yxzjhm; //有效证件号码
      this.form.telPhone = newValue.sjhm; //手机号码
      this.form.contactPhone = newValue.lxdh; //联系电话
      this.form.homeAddress = newValue.jtzz; //家庭住址
      this.form.bysj = this.formatPropsDateToFormDate(newValue.bysj); //毕业时间
      // this.form.jltdsj = this.formatPropsDateToFormDate(newValue.jltdsj); //毕业时间
      this.form.imageSrc =
        newValue.zp == "" ? "" : "data:image/png;base64," + newValue.zp; //照片

      this.form.firstEducation = newValue.dyxl; //第一学历
      this.form.firstDegree = newValue.dyxlxw; //第一学历学位
      this.form.firstPeriod = newValue.dyxlxz; //第一学历学制
      this.form.firstCollege = newValue.dyxlbyxx; //第一学历毕业院校
      this.form.firstGraduationDate = this.formatPropsDateToFormDate(
        newValue.dyxlbysj
      ); //第一学历毕业时间
      this.form.firstProfession = newValue.dyxlzy; //第一学历专业
      this.form.collegeCategory = newValue.xxlb; //学校类别
      this.form.height = newValue.sg; //身高
      this.form.weight = newValue.tz; //体重
      // this.form.followEducation = newValue.hxxl; //后续学历
      // this.form.followDegree = newValue.hxxlxw; //后续学历学位
      // this.form.followPeriod = newValue.hxxlxz; //后续学历学制
      // this.form.followCollege = newValue.hxxlbyxx; //后续学历毕业院校
      // this.form.followGraduationDate = this.formatPropsDateToFormDate(
      //   newValue.hxxlbysj
      // ); //后续学历毕业时间
      // this.form.followProfession = newValue.hxxlzy; //后续学历专业

      this.form.toWorkDate = this.formatPropsDateToFormDate(newValue.cjgzsj); //参加工作时间
      this.form.company = newValue.xgzdw; //现工作单位
      this.form.department = newValue.xbm; //现部门
      this.form.post = newValue.zwhgw; //职务或岗位
      this.form.ExpertiseObtainDate = this.formatPropsDateToFormDate(
        newValue.zyjszgjhdsj
      ); //专业技术资格取得时间
      this.form.appointmentDate = this.formatPropsDateToFormDate(
        newValue.xpzyjsgwjprsj
      ); //现聘专业技术岗位及聘任时间

      this.form.note = newValue.bz; //备注
      //工作培训学习简历
      this.form.gzpxxxjl = newValue.gzpxxxjl;
      // newValue.ds_zpqs_bmxx_gzpxxxjl.forEach(element => {
      //   let item = {
      //     gzpxxxjlid: element.gzpxxxjlid,
      //     startDate: this.formatPropsDateToFormDate(element.ksrq),
      //     endDate: this.formatPropsDateToFormDate(element.jsrq),
      //     location: element.dd,
      //     content: element.nr,
      //     show: true,
      //     modified: false,
      //     editableStartDate: this.formatPropsDateToFormDate(element.ksrq),
      //     editableEndDate: this.formatPropsDateToFormDate(element.jsrq),
      //     editableLocation: element.dd,
      //     editableContent: element.nr
      //   };
      //   this.form.resume.push(item);
      // });

      //家庭主要成员
      newValue.ds_nbzp_bmxx_jtzycy.forEach((element) => {
        let item = {
          jtzycyid: element.jtzycyid, //id
          name: element.xm,
          relationship: element.ybrgx, //与本人关系
          age: element.nl,
          degree: element.xl, //学历
          profession: element.zy, //专业
          companyAndPost: element.xgzdwjgw, //现工作单位及岗位
          show: true,
          modified: false,
          editableName: element.xm,
          editableRelationship: element.ybrgx,
          editableAge: element.nl,
          editableDegree: element.xl,
          editableProfession: element.zy,
          editableCompanyAndPost: element.xgzdwjgw,
        };
        this.form.homeMainMember.push(item);
      });
    },
    /**
     * 获取校验后的数据
     */
    getData() {
      // let data_gzpxxxjl = [];
      // let resume = this.form.resume;
      // for (let i = 0; i < resume.length; i++) {
      //   let item = {
      //     gzpxxxjlid: resume[i].gzpxxxjlid ? resume[i].gzpxxxjlid : "",
      //     ksrq: resume[i].startDate, //开始日期
      //     jsrq: resume[i].endDate, //结束日期
      //     dd: resume[i].location, //地点
      //     nr: resume[i].content //内容
      //   };
      //   data_gzpxxxjl.push(item);
      // }
      let data_jtzycy = [];
      let member = this.form.homeMainMember;
      for (let i = 0; i < member.length; i++) {
        let item = {
          jtzycyid: member[i].jtzycyid ? member[i].jtzycyid : "",
          xm: member[i].name,
          ybrgx: member[i].relationship,
          nl: member[i].age,
          xl: member[i].degree,
          zy: member[i].profession,
          xgzdwjgw: member[i].companyAndPost,
        };
        data_jtzycy.push(item);
      }
      let data = {
        // yhid: share.get("userInfo").yhid, //用户id
        xm: this.form.name, //姓名
        xb: this.form.gender, //性别
        mz: this.form.nation, //民族
        csrq: this.form.birthDate, //出生日期
        csd: this.form.birthPlace, //出生地
        zzmm: this.form.politicsFace, //政治面貌
        rdsj: this.form.joinPartyDate, //入党时间
        yxzjhm: this.form.identityNumber, //有效证件号码
        sjhm: this.form.telPhone, //手机号码
        lxdh: this.form.contactPhone, //联系电话
        jtzz: this.form.homeAddress, //家庭住址
        zp: this.form.imageSrc.split(",")[1], //照片

        dyxl: this.form.firstEducation, //第一学历
        dyxlxw: this.form.firstDegree, //第一学历学位
        dyxlxz: this.form.firstPeriod, //第一学历学制
        dyxlbyxx: this.form.firstCollege, //第一学历毕业院校
        dyxlbysj: this.form.firstGraduationDate, //第一学历毕业时间
        dyxlzy: this.form.firstProfession, //第一学历专业
        xxlb: this.form.collegeCategory, //学校类别
        bysj: this.form.bysj, //毕业时间
        // jltdsj: this.form.jltdsj, //简历投递时间
        sg: this.form.height, //身高
        tz: this.form.weight, //体重
        // hxxl: this.form.followEducation, //后续学历
        // hxxlxw: this.form.followDegree, //后续学历学位
        // hxxlxz: this.form.followPeriod, //后续学历学制
        // hxxlbyxx: this.form.followCollege, //后续学历毕业院校
        // hxxlbysj: this.form.followGraduationDate, //后续学历毕业时间
        // hxxlzy: this.form.followProfession, //后续学历专业

        cjgzsj: this.form.toWorkDate, //参加工作时间
        xgzdw: this.form.company, //现工作单位
        xbm: this.form.department, //现部门
        zwhgw: this.form.post, //职务或岗位
        zyjszgjhdsj: this.form.ExpertiseObtainDate, //专业技术资格取得时间
        xpzyjsgwjprsj: this.form.appointmentDate, //现聘专业技术岗位及聘任时间

        // data_zpqs_bmxx_gzpxxxjl: JSON.stringify(data_gzpxxxjl), //工作培训学习简历
        gzpxxxjl: this.form.gzpxxxjl, //工作培训学习简历
        data_zpqs_bmxx_jtzycy: JSON.stringify(data_jtzycy), //家庭主要成员

        bz: this.form.note, //备注
      };
      return data;
    },
    /**
     * 校验数据是否都已填写
     */
    validate() {
      let validated = false;
      this.$refs.form.validate((valid) => {
        if (valid) {
          validated = true;
        } else {
          validated = false;
        }
      });
      //检查是否已选择照片
      if (this.form.imageSrc == "") {
        this.showMessage = true;
        validated = false;
        // return false;
      } else {
        this.showMessage = false;
      }
      //检查工作培训学习简历是否已添加
      // if (this.form.resume.length == 0) {
      //   this.showResumeMessage = true;
      //   validated = false;
      //   // return false;
      // } else {
      //   this.showResumeMessage = false;
      // }
      //检查家庭成员是否已添加
      if (this.form.homeMainMember.length == 0) {
        this.showHomeMemberMessage = true;
        validated = false;
        // return false;
      } else {
        this.showHomeMemberMessage = false;
      }
      return validated;
    },
    //家庭成员要显示code的对应的标签
    getCodeLabel(key, selectKey) {
      return share.getValue(key, selectKey);
    },
    delHomeMember(index) {
      this.form.homeMainMember.splice(index, 1);
    },
    saveHomeMember(item, index) {
      let key = "itemHomeMember" + index;
      this.$refs[key][0].validate((valid) => {
        if (valid) {
          item.name = item.editableName;
          item.relationship = item.editableRelationship;
          item.age = item.editableAge;
          item.degree = item.editableDegree;
          item.profession = item.editableProfession;
          item.companyAndPost = item.editableCompanyAndPost;
          item.modified = false;
          item.show = true;
        }
      });
    },
    modifyHomeMember(item) {
      item.modified = true;
    },
    addHomeMember() {
      // this.validate();
      let item = {
        jtzycyid: "", //id
        name: "",
        relationship: "", //与本人关系
        age: "",
        degree: "", //学历
        profession: "", //专业
        companyAndPost: "", //现工作单位及岗位
        show: false,
        modified: true,
        editableName: "",
        editableRelationship: "",
        editableAge: "",
        editableDegree: "",
        editableProfession: "",
        editableCompanyAndPost: "",
      };
      this.form.homeMainMember.push(item);
    },
    delResume(index) {
      this.form.resume.splice(index, 1);
    },
    saveResume(item, index) {
      let key = "itemResume" + index;
      this.$refs[key][0].validate((valid) => {
        if (valid) {
          item.startDate = item.editableStartDate;
          item.endDate = item.editableEndDate;
          item.location = item.editableLocation;
          item.content = item.editableContent;
          item.modified = false;
          item.show = true;
        }
      });
    },
    modifyResume(item) {
      item.modified = true;
    },
    addResume() {
      let item = {
        gzpxxxjlid: "",
        startDate: "",
        endDate: "",
        location: "",
        content: "",
        show: false,
        modified: true,
        editableStartDate: "",
        editableEndDate: "",
        editableLocation: "",
        editableContent: "",
      };
      this.form.resume.push(item);
    },
    imageChange(file) {
      const isLt2M = file.size / 1024 / 1024 < 0.1;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 100kb!");
      }
      if (isLt2M) {
        let that = this;
        this.getBase64(file.raw).then((src) => {
          that.form.imageSrc = src;
        });
      }
      // fileList = [];
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let imageSrc;
        reader.readAsDataURL(file);
        reader.onload = function () {
          imageSrc = reader.result;
        };
        reader.onloadend = function () {
          resolve(imageSrc);
        };
        reader.onerror = function (err) {
          reject(err);
        };
      });
    },
  },
};
</script>

<style lang="scss">
.baseinfo-image {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
  .image {
    margin: 10px;
    padding: 20px;
    width: 150px;
    height: 180px;
  }
}
.regisInfo {
  margin: 20px 0 0 0;
  background-color: #f2f2f2;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    .title {
      font-weight: bold;
      margin-bottom: 20px;
    }
    .info {
      margin-bottom: 20px;
    }
  }
  .view {
    align-self: flex-end;
    color: #2a8ae0;
    &:hover {
      cursor: pointer;
    }
  }
  .right {
    color: #2a8ae0;
    span {
      margin: 0px 20px;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
.red {
  color: #f56c6c;
}
.show {
  display: block;
}
.hide {
  display: none;
}
.header {
  font-weight: bold;
  padding: 10px;
  padding-left: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modify {
  color: #2a8ae0;
  &:hover {
    cursor: pointer;
  }
}
.delete {
  color: #ff5858;
  &:hover {
    cursor: pointer;
  }
}
</style>
